// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"a30cd47f","798":"66cd8402","971":"f8db3783"}[chunkId] + ".chunk.js";
};